<template>
	<div class="view-forgot-password">
		<password-forgot-form
			class="view-forgot-password__form"
			:loading="isLoading"
			:errors="errors"
			@submit="remindPassword"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import PasswordForgotForm from '@/components/password/forgot/PasswordForgotForm.vue';
import { ERRORS } from '@/constants/errors/constants';
import { authActions } from '@/store/modules/auth';
import { RemindPasswordPayload } from '@/store/modules/auth/types';
import { InstanceApiErrors, mapErrorMessagesToInstance, onApiError } from '@/tools/helpers';

export default defineComponent({
	components: {
		PasswordForgotForm,
	},

	data() {
		return {
			errors: {} as InstanceApiErrors,
		};
	},

	computed: {
		isLoading(): boolean {
			return this.$isLoading(['auth/remindPassword']);
		},
	},

	methods: {
		async remindPassword(data: RemindPasswordPayload) {
			try {
				await authActions.remindPassword(data);
				this.$toast.open({
					message:
						'If your email address exists in our database, you will receive a password recovery link in a few minutes.',
					timeout: 6000,
				});
				this.$router.push({ name: 'login' });
			} catch (e) {
				onApiError(e, {
					422: error => {
						const { errors = {} } = error.response?.data ?? {};

						mapErrorMessagesToInstance(errors, this.errors);
					},
					default: () => {
						this.$toast.open({
							message: ERRORS.GENERIC_ERROR_MESSAGE,
						});
					},
				});
			}
		},
	},
});
</script>

<style lang="scss">
.view-forgot-password {
	display: flex;
	align-items: center;

	&__form {
		@include max-md-and-portrait {
			display: grid;
			grid-template-columns: repeat(12, 1fr);
		}

		.form__header {
			grid-column: 1 / span 4;

			@include max-md-and-portrait {
				padding: 0;
			}
		}

		.form__content {
			grid-column: 7 / span 6;
			padding: 1.5rem 0;

			@include max-md-and-portrait {
				padding: 0;
			}
		}
	}
}
</style>
